module.exports = __webpack_public_path__ + "media/tr_tr_s2_Emel.da6a5a4f.mp3";